'use client';

import { motion } from 'motion/react';

import { REVEAL_STAGGER, TextReveal } from '@/components/elements/text-reveal';

interface UseCaseQuoteProps {
  quote: string;
  description: string;
}

export function UseCaseQuote({ quote, description }: UseCaseQuoteProps) {
  return (
    <section>
      <div className="container">
        <div className="border-foreground/10 border-t" />
      </div>
      <div className="py-16 md:py-20">
        <div className="container text-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={{ hidden: {}, visible: {} }}
          >
            <TextReveal mode="animate">
              <blockquote className="font-display text-2xl leading-tight tracking-tight italic md:text-3xl lg:text-[36px]">
                &ldquo;{quote}&rdquo;
              </blockquote>
            </TextReveal>
            <TextReveal
              mode="animate"
              delay={REVEAL_STAGGER * 2}
              className="mt-6"
            >
              <p className="text-muted-foreground mx-auto max-w-[660px] text-base leading-7">
                {description}
              </p>
            </TextReveal>
          </motion.div>
        </div>
      </div>
      <div className="container">
        <div className="border-foreground/10 border-t" />
      </div>
    </section>
  );
}
